<template>
    <span :class="['pill', color]">
        {{ value }}
    </span>
</template>

<script>
export default {
    props: {
        value: [String, Number],
        color: String,
    },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
    .pill {
        @include prevent-select;
        background-color: var(--stat-pill-background, $color-gray-60);
        color: $color-white;
        border-radius: px-to-rem(3px);
        height: $spacing-200;
        padding: 0 calc($spacing-200 / 2.5);
    }

    .red {
        --stat-pill-background: #{$color-red};
    }

    .yellow {
        --stat-pill-background: #{$color-yellow};
    }

    .green {
        --stat-pill-background: #{$color-green};
    }
</style>
